import { css } from '@emotion/react'
import { Theme } from '@mui/material/styles'

export const liveSelectedDetailContainer = ({ theme }: { theme: Theme }) => css`
  display: flex;
  flex-direction: column;
  padding: 0 ${theme.spacing(2)} ${theme.spacing(2)};
  gap: ${theme.spacing(1)};
`

export const liveSelectedHeader = ({ theme }: { theme: Theme }) => css`
  display: flex;
  align-items: center;
  justify-content: space-between;
  flex-grow: 1;
  padding-top: ${theme.spacing(2)};

  button {
    padding-left: 12px;
  }

  svg {
    height: 20px !important;
    margin: 0 0 0 4px !important;
  }
`

export const liveSelectedContent = ({ theme }: { theme: Theme }) => css`
  display: flex;
  flex-direction: column;
  padding: ${theme.spacing(2)} 0;
  gap: ${theme.spacing(5)};
`

export const liveSelectedStaleWarning = ({ theme }: { theme: Theme }) => css`
  background: #ffc107;
  padding: ${theme.spacing(0.75)} ${theme.spacing(1)};
  display: flex;
  align-items: center;
  gap: ${theme.spacing(1)};
  margin-bottom: ${theme.spacing(1)};
`

export const liveSelectedLastUpdated = ({ theme }: { theme: Theme }) => css`
  margin-bottom: ${theme.spacing(0.5)};
  display: flex;
  flex-direction: row;
  gap: ${theme.spacing(0.5)};
`
export const liveSelectedSection = ({ theme }: { theme: Theme }) => css`
  display: flex;
  flex-direction: column;
  gap: ${theme.spacing(3)};
  margin-bottom: ${theme.spacing(4)};
`

export const liveSelectedProperty = ({ theme }: { theme: Theme }) => css`
  display: flex;
  flex-direction: column;
  gap: ${theme.spacing(0.5)};
  padding: ${theme.spacing(2)};
  background-color: white;
`
export const liveSelectedPropertyRow = ({ theme }: { theme: Theme }) => css`
  display: inline;
  gap: ${theme.spacing(0.5)};
  padding: ${theme.spacing(1)};
  background-color: white;
`

export const liveSelectedImage = ({ theme }: { theme: Theme }) => css`
  width: 100%;
  margin: ${theme.spacing(1)} 0;
  border-radius: ${theme.shape.borderRadius}px;
  background-color: black;
  object-fit: cover;
  display: block;
`

export const liveSelectedClearButton = css`
  align-self: flex-end;
`
